import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText } from 'data/components';

class Clamp extends PureComponent {
    static propTypes = {
        line: PropTypes.object.isRequired
    };

    render() {
        const { line } = this.props;
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={line.get('label')} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.macAddress')}
                            itemContent={
                                line.get('macAddress')
                                    ? line
                                          .get('macAddress')
                                          .match(/.{1,2}/g)
                                          .join(':')
                                    : 'N/A'
                            }
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.type')}
                            itemContent={Translator.translate(`general.productModules.${line.get('type')}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={line.get('code')} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.reversePolarity')}
                            itemContent={
                                line.get('reversedPolarity') === 1 ? Translator.translate('general.yes') : Translator.translate('general.no')
                            }
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.threshold')} itemContent={line.get('threshold')} />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

export default Clamp;



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/ProductModule/Clamp/index.js